module.exports = function getPropertiesOrderData(expectedOrder, propName) {
	return expectedOrder[propName];
};
